import React, { useEffect, useState } from 'react'
import styles from './Footer.module.css'
import IconComponent from '../IconComponent/IconComponent'
import { FaLocationDot, FaPhone, FaEnvelope, FaInstagram, FaFacebook, FaLinkedin, FaArrowRight } from 'react-icons/fa6';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.items}>
                <div className={`${styles.item} ${styles.i1}`}>
                    {!isMobile && (<div className={styles.itemSpace}></div>)}
                    <div className={styles.itemWrapper}>
                        <div className={`${styles.content} ${isMobile ? '' : `${styles.contentBorder} ${styles.bottomContent}`}`}>
                            <img src={'https://sazuli.pt/uploads/Logo Branco.png'} alt="Logo" className={styles.logo} onClick={() => navigate("/")} />
                        </div>
                        {isMobile ? (
                            <div className={`${styles.content}`}>
                                <div className={styles.navlinks}>
                                    <Link to={"/servicos"}>Serviços</Link>
                                    <Link to={"/sazuli"}>Sazuli</Link>
                                    <Link to={"/parceiros"}>Parceiros</Link>
                                    <Link to={"/contactos"}>Contactos</Link>
                                </div>
                            </div>
                        ) : (
                            <div className={`${styles.content} ${styles.topContent}`}>
                                <div className={styles.info}>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaLocationDot} size={20} /></span>
                                        <a
                                            href="https://maps.app.goo.gl/utLDg6Xsx9q7sv9u8"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Zona Industrial de Pinhal Basto 4615-669 Macieira da Lixa
                                        </a>
                                    </div>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaPhone} size={20} /></span>
                                        <a className={styles.iconTextSpanRight} href='tel:+351255490460'>(+351) 255 490 460</a> <span>(Chamada para a rede fixa nacional)</span>
                                    </div>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaEnvelope} size={20} /></span>
                                        <a href='mailto:geral@sazuli.pt'>geral@sazuli.pt</a>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                {isMobile ? (
                    <div className={`${styles.item} ${styles.i3}`}>
                        <div className={styles.content}>
                            <div className={styles.socials}>
                                <span className={styles.socials_title}>Dê forma ao seu próximo projeto.</span>
                                <div className={styles.btn_contact}>
                                    <span onClick={() => navigate("/contactos")}>Contacte-nos</span>
                                    <IconComponent icon={FaArrowRight} size={15} />
                                </div>
                                <div className={styles.socials_icons}>
                                    <a href="https://www.instagram.com/sazuli_ceramicas" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaInstagram} size={25} />
                                    </a>
                                    <a href="https://www.facebook.com/sazuli.lda" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaFacebook} size={25} />
                                    </a>
                                    <a href="https://www.linkedin.com/in/sazuli-lda-a0520b312" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaLinkedin} size={25} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={`${styles.item} ${styles.i2}`}>
                        <div className={`${styles.content} ${styles.bothContent} ${styles.contentBorder}`}>
                            <div className={styles.navlinks}>
                                <Link to={"/servicos"}>Serviços</Link>
                                <Link to={"/sazuli"}>Sazuli</Link>
                                <Link to={"/parceiros"}>Parceiros</Link>
                                <Link to={"/contactos"}>Contactos</Link>
                            </div>
                        </div>
                        <div className={styles.contentSmall}>
                            <div className={styles.footer_info}>
                                <span>@2025 Sazuli</span>
                                <div className={styles.footerLinks}>
                                    <a
                                        href="https://www.livroreclamacoes.pt/Inicio/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className={styles.link}>Livro de Reclamações</span>
                                    </a>

                                    <a
                                        href="/politica-de-cookies"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <span className={styles.link}>Política de Cookies</span>
                                    </a>
                                </div>
                                <a href="https://hardcreative.pt" target="_blank" rel="noopener noreferrer">
                                    <span>Desenvolvido por <span className={styles.link}>Hard Creative Studio</span></span>
                                </a>
                            </div>
                        </div>
                    </div>
                )}
                <div className={`${styles.item} ${styles.i3}`}>
                    {isMobile ? (
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <div className={`${styles.content}`}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <div className={styles.info}>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaLocationDot} size={20} /></span>
                                        <a
                                            href="https://maps.app.goo.gl/utLDg6Xsx9q7sv9u8"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Zona Industrial de Pinhal Basto 4615-669 Macieira da Lixa
                                        </a>                                    </div>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaPhone} size={20} /></span>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '0.5rem'
                                        }}>
                                            <a href='tel:+351255490460'>(+351) 255 490 460</a><span>(Chamada para a rede fixa nacional)</span>
                                        </div>
                                    </div>
                                    <div className={styles.iconText}>
                                        <span><IconComponent icon={FaEnvelope} size={20} /></span>
                                        <a href="mailto:geral@sazuli.pt">geral@sazuli.pt</a>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.footerLinksMov}>

                                <a
                                    href="https://www.livroreclamacoes.pt/Inicio/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className={styles.link}>Livro de Reclamações</span>
                                </a>

                                <a
                                    href="/politica-de-cookies"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className={styles.link}>Política de Cookies</span>
                                </a>
                            </div>

                            <div className={styles.contentSmall}>
                                <div className={styles.footer_info}>
                                    <span>@2025 Sazuli</span>
                                    <span>
                                        <a href="https://hardcreative.pt" target="_blank" rel="noopener noreferrer">
                                            <span>Desenvolvido por <span className={styles.link}>Hard Creative Studio</span></span>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.content}>
                            <div className={styles.socials}>
                                <span className={styles.socials_title}>Dê forma ao seu próximo projeto.</span>
                                <div className={styles.btn_contact}>
                                    <span onClick={() => navigate("/contactos")}>Contacte-nos</span>
                                    <IconComponent icon={FaArrowRight} size={15} />
                                </div>
                                <div className={styles.socials_icons}>
                                    <a href="https://www.instagram.com/sazuli_ceramicas" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaInstagram} size={25} />
                                    </a>
                                    <a href="https://www.facebook.com/sazuli.lda" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaFacebook} size={25} />
                                    </a>
                                    <a href="https://www.linkedin.com/in/sazuli-lda-a0520b312" target="_blank" rel="noopener noreferrer">
                                        <IconComponent icon={FaLinkedin} size={25} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div >
    )
}

export default Footer
